import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { task, timeout } from 'ember-concurrency';
import { action } from '@ember/object';

export default class CountdownTimer extends Component {
  @tracked timeLeft = '24:00:00';
  @tracked secondsRemaining;
  
  constructor() {
    super(...arguments);
    this.initializeTimer();
    this.countdownTask.perform();
  }

  initializeTimer() {
    const now = Date.now(); // Current time in milliseconds
    const actionTime = this.args.startTime; // Time when the action happened
    const elapsedSeconds = Math.floor((now - actionTime) / 1000); // How many seconds passed since the action
    const totalSeconds = 24 * 60 * 60; // 24 hours in seconds
    
    this.secondsRemaining = Math.max(0, totalSeconds - elapsedSeconds);
    this.timeLeft = this.formatTime(this.secondsRemaining);
  }

  @action 
  startTimeUpdate() {
    this.initializeTimer();
    this.countdownTask.perform();
  }

  @task
  *countdownTask() {
    while (this.secondsRemaining > 0) {
      yield timeout(1000);
      this.secondsRemaining--;
      this.timeLeft = this.formatTime(this.secondsRemaining);
    }
  }

  formatTime(seconds) {
    const hours = Math.floor(seconds / (60 * 60));
    const minutes = Math.floor((seconds % (60 * 60)) / 60);
    const remainingSeconds = seconds % 60;

    return [hours, minutes, remainingSeconds]
      .map(unit => String(unit).padStart(2, '0'))
      .join(':');
  }
}